import { formatInTimeZone } from "date-fns-tz";

/** Earliest month for which payslips may be generated (SSOT). */
export const PAYSLIP_MIN_YEAR = 2025;
export const PAYSLIP_MIN_MONTH = 7; // July

/** IANA timezone for determining the current month boundary (SSOT). */
const PAYSLIP_TIMEZONE = "Europe/Zurich";

/**
 * Returns current year and month in Europe/Zurich timezone.
 * Uses formatInTimeZone to avoid fake Date objects from toZonedTime.
 */
export function getCurrentPayslipMonth(): { year: number; month: number } {
  const nowStr = formatInTimeZone(new Date(), PAYSLIP_TIMEZONE, "yyyy-MM");
  const [year, month] = nowStr.split("-").map(Number);
  return { year, month };
}

/**
 * Checks whether a given year/month is within the valid payslip range:
 *   - At or after PAYSLIP_MIN (year*12+month comparison for safe cross-year logic)
 *   - At or before current month in Europe/Zurich
 */
export function isValidPayslipMonth(year: number, month: number): boolean {
  const minVal = PAYSLIP_MIN_YEAR * 12 + PAYSLIP_MIN_MONTH;
  const targetVal = year * 12 + month;
  const current = getCurrentPayslipMonth();
  const currentVal = current.year * 12 + current.month;
  return targetVal >= minVal && targetVal <= currentVal;
}
